// extracted by mini-css-extract-plugin
module.exports = {"emptyDataNotice":"NoResultsMessage_emptyDataNotice__zvrGj","heading":"NoResultsMessage_heading__UGzwU"};